import { StatusBadge, TStatusBadgeProps } from '@treezor/design-system';
import { useTranslation } from 'react-i18next';

import { cardTransactionPaymentStatus, TCardTransactionPaymentStatus } from '@/features/cards/store/models/card.model';

export const paymentStatusColor: {
  [key in TCardTransactionPaymentStatus]: TStatusBadgeProps['color'];
} = {
  A: 'orange',
  R: 'orange',
  S: 'green',
  M: 'orange',
  C: 'darkOrange',
  I: 'red',
  V: 'orange',
};

interface IPaymentStatusCellProps {
  status: TCardTransactionPaymentStatus;
}

export function PaymentStatusCell({ status }: IPaymentStatusCellProps) {
  const { t } = useTranslation();
  return (
    <StatusBadge
      emphasis="low"
      size="s"
      color={paymentStatusColor[status] || 'gray'}
      label={t(`pages.currentProfiles.cards.transactions.table.status.${cardTransactionPaymentStatus[status]}`)}
    />
  );
}
